import React from 'react'

import { ErrorLayout } from './ErrorLayout'

type Error500Props = {
  //
}

export const Error500: React.FC<Error500Props> = () => (
  <ErrorLayout code="500" title="Произошла внутренняя ошибка">
    <p>
      Уважаемый пользователь, по каким-то причинам произошла внутренняя ошибка.
      <br />
      Если вы уверенны, что это случилось по нашей вине, пожалуйста, сообщите
      нам об этой проблеме и не забудьте указать адрес, с которого вы сюда
      попали.
    </p>
  </ErrorLayout>
)
